// Centralized API base URL for frontend
// In development, leave REACT_APP_API_BASE_URL empty to use CRA proxy
// In production (e.g., Vercel), set REACT_APP_API_BASE_URL to your backend origin
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export { API_BASE_URL };


